import React from "react";
import { Container, Card, Row, Col, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
import AppNavbar from "../components/AppNavbar";

const PaymentPage = () => {
  const iban = "TR00 0000 0000 0000 0000 0000 00";

  const plans = [
    { title: "Öğrenci", price: "1499₺ / yıl", desc: "Öğrenci Belgesi İletilmeli" },
    { title: "Eczacı, Hekim ve Akademisyen", price: "1999₺ / yıl", desc: "Diploma veya Mezuniyet Belgesi İletilmeli" },
  ];

  const whatsappNumber = "905555555555"; // 🔹 Buraya kendi numaranı yaz (başında 9 ve ülke kodu olacak)

  return (
    <>
      <AppNavbar />
      <section
        className="py-5"
        style={{
          background: "linear-gradient(180deg, #E7F5F2 0%, #FFFFFF 100%)",
          minHeight: "100vh",
        }}
      >
        <Container>
          {/* Başlık */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-5"
          >
            <h2 className="fw-bold" style={{ color: "#2D8A7A" }}>
              Ödeme Sayfası
            </h2>
            <p className="text-muted mt-3">
              Majistral App’e erişim sağlamak veya üyeliğinizi uzatmak için aşağıdaki paketlerden size uygun olana göre ödeme yapmanız gerekiyor.
            </p>
          </motion.div>

          {/* Planlar */}
          <Row className="g-4 justify-content-center">
            {plans.map((plan, idx) => (
              <Col key={idx} md={4}>
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.2 }}
                >
                  <Card className="pricing-card text-center p-4 shadow-sm border-0">
                    <h5 className="fw-bold" style={{ color: "#2D8A7A" }}>
                      {plan.title}
                    </h5>
                    <h3 className="fw-bold mt-3">{plan.price}</h3>
                    <p className="text-muted">{plan.desc}</p>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>

          {/* Ödeme Bilgileri */}
          <div className="text-center mt-5">
            <Card className="p-4 shadow-sm d-inline-block" style={{ borderRadius: "15px" }}>
              <h5 className="fw-bold" style={{ color: "#2D8A7A" }}>
                Ödeme Bilgileri
              </h5>
              <p className="mt-3 mb-1">Banka: -</p>
              <p className="mb-1 fw-semibold">Hesap Adı: -</p>
              <p className="fw-bold mb-0" style={{ color: "#2D8A7A" }}>
                IBAN: {iban}
              </p>
            </Card>

            <p className="text-muted mt-4" style={{ maxWidth: "600px", margin: "0 auto" }}>
              Ödemenizi yaptıktan sonra{" "}
              <strong>dekontunuzu WhatsApp üzerinden</strong> bize gönderebilirsiniz.
              Üyelik onay süreci genellikle 24 saat içinde tamamlanır.
            </p>

            {/* Yeni Bilgilendirme */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
              className="mt-4"
            >
              <p className="fw-semibold text-success">
                💬 Üyeliğinizin onaylanması için gerekli belgelerin de dekont ile birlikte WhatsApp üzerinden iletilmesi gerekmektedir.
              </p>
              <a
                href={`https://wa.me/${whatsappNumber}?text=Merhaba%20Majistral%20App,%20ödeme%20yaptım%20üyeliğimin%20onaylanmasını%20rica%20ederim.`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  variant="success"
                  size="lg"
                  className="d-inline-flex align-items-center hover-scale"
                  style={{
                    backgroundColor: "#25D366",
                    borderColor: "#25D366",
                    borderRadius: "50px",
                  }}
                >
                  <FaWhatsapp className="me-2" size={20} />
                  WhatsApp ile İletişime Geç
                </Button>
              </a>
            </motion.div>

            <Button
              variant="outline-primary"
              href="/"
              className="mt-4 hover-scale"
              style={{ borderColor: "#2D8A7A", color: "#2D8A7A" }}
            >
              Ana Sayfaya Dön
            </Button>
          </div>
        </Container>
      </section>
    </>
  );
};

export default PaymentPage;
